module.exports = __webpack_public_path__ + "img/admin_adv_23.5e476aac.png";